import React from "react";
import {observer} from "mobx-react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from '@mui/material'
import './modal.scss'
import {useStores} from "../../Hooks";
import {snackbarTypesEnum} from "../../enums";

const AlertSnackbar = observer(() => {
    const {modalStore} = useStores();

    function closeDialog(e, reason) {
        if (reason === 'clickaway' && modalStore.keepOpen) {
            return;
        }
        modalStore.alertMessage = '';
        modalStore.alertType = snackbarTypesEnum.INFO;
    }

    return (
        <Snackbar
            open={!!modalStore.alertMessage}
            autoHideDuration={modalStore.keepOpen ? null : 5000}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            onClose={closeDialog}
            className='error-message-alert'
            data-testId='alert-snackbar'
        >
            <Alert severity={modalStore.alertType}>
                {modalStore.alertMessage}
            </Alert>
        </Snackbar>
    )
});

export default AlertSnackbar;
